import React from "react";
import SystemBetsDetailTicketHeader from "./SystemBetsDetailTicketHeader";
import SystemBetsDetailTicketTuples from "./SystemBetsDetailTicketTuples";
import SystemBetsDetailTicketFixtures from "./SystemBetsDetailTicketFixtures";
import SystemBetsDetailTicketFooter from "./SystemBetsDetailTicketFooter";

export default function SystemBetsDetailTicket(props) {
    const ticketData = props.ticketData;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; // TODO: add "isEstero" in configuration
	const isCashout = props.isCashout;
	const terminalCopy = props.terminalCopy;
	const printAgainTerminalRec = props.printAgainTerminalRec;
	const skinProperties = props.skinProperties;
	const user = props.user;
	const conf = props.conf;

    return (
        <div id={"ticket-" + ticketData.idTicket} className="ticket-container">
			<SystemBetsDetailTicketHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} conf={conf} user={user} skinProperties={skinProperties}  ticketData={ticketData} psvVincPiazzSports={props.psvVincPiazzSports} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
			<SystemBetsDetailTicketFixtures customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} conf={conf} user={user} skinProperties={skinProperties}  ticketData={ticketData} psvVincPiazzSports={props.psvVincPiazzSports} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
			<SystemBetsDetailTicketTuples customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} conf={conf} user={user} skinProperties={skinProperties}  ticketData={ticketData} psvVincPiazzSports={props.psvVincPiazzSports} frontendType={frontendType} aamsEnviroment={aamsEnviroment} /> 
			<SystemBetsDetailTicketFooter customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} conf={conf} user={user} skinProperties={skinProperties}  ticketData={ticketData} psvVincPiazzSports={props.psvVincPiazzSports} frontendType={frontendType} aamsEnviroment={aamsEnviroment} /> 
		</div>
    )
}
    